import React from 'react'
import clsx from 'clsx'
import i18n from '@pureartisan/simple-i18n'
import { makeStyles } from '@material-ui/core/styles'
import { Button, Box, Typography } from '@material-ui/core'
import useStore from '../store'
import { PanelHeader, PanelBody } from '../SlideoutPanel'
import Accordion from '../Accordion'

// Styles for this component.
const styles = makeStyles(theme => ({
  root: {
    '& .ddk-accordion .share-icon': {
      width: '16px',
      height: '16px',
      marginBottom: '-2px',
    },
  },
  allButton: {
    // TODO: globalize btn styles
    marginTop: theme.spacing(2),
    color: theme.palette.secondary.main,
    background: theme.extras.variables.colors.accent,
    fontSize: '14px',
    fontWeight: 400,
  },
  details: {
    marginBlockStart: 0,
    color: theme.extras.variables.colors.textSubtle,
    fontWeight: 400,
    lineHeight: '21px',
  },
}))

const FaqPanel = () => {
  const { expanded, setStoreValues } = useStore(state => ({
    expanded: state.expandedFaqs,
    setStoreValues: state.setStoreValues,
  }))

  const faqObjects = i18n.translate('FAQ', {
    returnObjects: true,
  })

  const handleEvent = (val, e) => {
    if (val === 'openAll') {
      const expandedFaqs = faqObjects.reduce(
        (accum, curr) => {
          accum[curr.id] = true
          return accum
        },
        {},
      )
      setStoreValues({ expandedFaqs })
    } else if (val === 'hideAll') {
      setStoreValues({ expandedFaqs: {} })
    } else {
      // individual faq clicked - toggle its visibility
      const expandedFaqs = { ...expanded }
      expandedFaqs[val] = !expandedFaqs[val]
      setStoreValues({ expandedFaqs })
    }
  }

  const allOpen = faqObjects.every(el => !!expanded[el.id])
  const clickEvent = allOpen ? 'hideAll' : 'openAll'
  const btnTextKey = allOpen
    ? 'BTN_HIDE_ALL'
    : 'BTN_SHOW_ALL'

  const classes = styles()

  return (
    <Box className={clsx(classes.root, 'panel-root')}>
      <PanelHeader
        title={i18n.translate(`PANEL_FAQ_TITLE`)}
      >
        <Button
          onClick={e => handleEvent(clickEvent, e)}
          className={classes.allButton}
        >
          {i18n.translate(btnTextKey)}
        </Button>
      </PanelHeader>
      <PanelBody id="faq-container">
        {faqObjects.map(el => {
          return (
            <Accordion
              key={el.title}
              summary={el.title}
              details={
                <Typography
                  variant="h2"
                  className={classes.details}
                  component="p"
                  color="textSecondary"
                  dangerouslySetInnerHTML={{
                    __html: el.content,
                  }}
                />
              }
              expanded={!!expanded[el.id]}
              id={`faq-${el.id}`}
              handleChange={e => {
                handleEvent(el.id, e)
              }}
            />
          )
        })}
      </PanelBody>
    </Box>
  )
}

export default FaqPanel
